import { createFileRoute } from '@tanstack/react-router';
import { PosImportPage } from '@/features/checkout/pages/pos-import-page';

export const Route = createFileRoute('/_app/imports/pos')({ component: PosImportPage });
